export default function productCatalogueReducer(state, action) {
  switch (action.type) {
    case 'GET_ALL_PRODUCTCATALOGUES':
      return {
        ...state,
        productCatalogues: action.payload,
        loading: false,
      }
    case 'ADD_PRODUCTCATALOGUE':
      return {
        ...state,
        productCatalogues: [action.payload, ...state.productCatalogues],
      }
    case 'ADD_ATTENDANCE':
      return {
        ...state,
        attendances: [action.payload, ...state.attendances],
      }
    case 'ADD_CUSTOMER':
      return {
        ...state,
        customers: [action.payload, ...state.customers],
      }
    case 'ADD_LEAVE':
      return {
        ...state,
        leaves: [action.payload, ...state.leaves],
      }
    case 'EDIT_PRODUCTCATALOGUE':
      const updatedProductCatalogue = action.payload

      const updatedSubCategories = state.productCatalogues.map((productCatalogue) => {
        if (productCatalogue._id === updatedProductCatalogue._id) {
          return updatedProductCatalogue
        }
        return productCatalogue
      })

      return {
        ...state,
        productCatalogues: updatedSubCategories,
      }
    case 'REMOVE_PRODUCTCATALOGUE':
      return {
        ...state,
        productCatalogues: state.productCatalogues.filter(
          (productCatalogues) => productCatalogues._id !== action.payload
        ),
      }

    case 'GET_ALL_ATTENDANCES':
      return {
        ...state,
        attendances: action.payload,
        loading: false,
        totalEmployee: action.totalEmployee,
      }

    case 'REMOVE_ATTENDANCE':
      return {
        ...state,
        attendances: state.attendances.filter((attendances) => attendances._id !== action.payload),
      }
    case 'GET_ALL_LEADS':
      return {
        ...state,
        leads: action.payload,
        loading: false,
      }

    case 'REMOVE_LEAD':
      return {
        ...state,
        leads: state.leads.filter((leads) => leads._id !== action.payload),
      }
    case 'GET_ALL_LEAVES':
      return {
        ...state,
        leaves: action.payload,
        loading: false,
      }

    case 'REMOVE_LEAVE':
      return {
        ...state,
        leaves: state.leaves.filter((leaves) => leaves._id !== action.payload),
      }

    case 'ADD_PRIMARY_SALES':
      return {
        ...state,
        primarySales: [action.payload, ...state.primarySales],
        loading: false,
      }
    case 'GET_ALL_PRIMARY_SALES':
      return {
        ...state,
        primarySales: action.payload,
        loading: false,
      }

    case 'REMOVE_PRIMARY_SALES':
      return {
        ...state,
        primarySales: state.primarySales.filter((primarySales) => primarySales._id !== action.payload),
      }
    case 'GET_ALL_CUSTOMERS':
      return {
        ...state,
        customers: action.payload,
        loading: false,
      }

    case 'REMOVE_CUSTOMER':
      return {
        ...state,
        customers: state.customers.filter((customers) => customers._id !== action.payload),
      }
    case 'GET_ALL_INCENTIVE':
      return {
        ...state,
        incentives: action.payload,
        loading: false,
      }

    case 'REMOVE_INCENTIVE':
      return {
        ...state,
        incentives: state.incentives.filter((incentives) => incentives._id !== action.payload),
      }
    case 'GET_ALL_SALES_RETURN':
      return {
        ...state,
        salesReturn: action.payload,
        loading: false,
      }

    case 'REMOVE_SALES_RETURN':
      return {
        ...state,
        salesReturn: state.salesReturn.filter((salesReturn) => salesReturn._id !== action.payload),
      }
    default:
      return state
  }
}
